import { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { get, isEmpty } from 'lodash'
import { apiGetLiveByid, apiPutLive } from '../../modules/auth/core/_requestLive'

import FromContent from './FromContent'

const EditLiveWrapper = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [content, setContent] = useState({})

  const enableSplashScreen = () => {
    const splashScreen = document.getElementById('splash-screen')
    if (splashScreen) splashScreen.style.setProperty('display', 'flex')
  }

  const disableSplashScreen = () => {
    const splashScreen = document.getElementById('splash-screen')
    if (splashScreen) splashScreen.style.setProperty('display', 'none')
  }

  const onSubmit = (value) => {
    const data = {
      active: value.active,
      title: value.title,
      link_url: value.link_url,
      public_date: value.public_date,
      end_date: value.end_date,
      live_type: value.live_type,
    }

    enableSplashScreen()
    apiPutLive(id, data)
      .then(console.log)
      .catch(console.error)
      .finally(() => navigate('/live'))
  }

  const getContents = (id) => {
    enableSplashScreen()
    apiGetLiveByid(id)
      .then((res) => setContent(get(res, 'data.data', {})))
      .catch(console.error)
      .finally(() => setTimeout(() => { disableSplashScreen() }, 200))
  }

  useEffect(() => {
    getContents(id)
    // eslint-disable-next-line
  }, [id])

  return (
    <div className="container" style={{ minHeight: '90vh' }}>
      {!isEmpty(content) && <FromContent type="edit" value={content} onSubmit={onSubmit} onCancel={() => navigate('/live')} />}
    </div>
  )
}

export default EditLiveWrapper

